import {AccountApplication} from "../types.ts";
import {
    Stack,
    Text
} from "@mantine/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";


export const useAccountApplicationsTableColumns = (accountId: string) => {

    if (!accountId) {
        throw new Error('accountId is required parameter')
    }

    const columns: DataTableColumn<AccountApplication>[] = [
        {
            accessor: 'applicationId',
            title: 'Application',
            ellipsis: true,
            // Sorts by applicationId, the accessor — NOT by the application
            // name the cell renders, which is not on every row.
            sortable: true,
            render: (item) => {
                return (
                    <Stack>
                        {item.application ? <NavLink to={`/applications/${item.applicationId}`}><Text fw={700}
                                                                                                      fs={'sm'}>{item.application.name}</Text></NavLink> :
                            <NavLink to={`/applications/${item.applicationId}`}><Text fs={'sm'}
                                                                                      fw={700}>{item.applicationId}</Text></NavLink>}
                    </Stack>
                )

            },

        },
        {
            accessor: 'accountApplicationStatus',
            title: 'Status',
            sortable: true,
        },
        {
            accessor: 'created',
            title: 'Created',
            sortable: true,
            render: (item) => formatTimestamp(item.created, 'MMM DD, YYYY'),
        }
    ];


    return {
        columns,
    };
};
